import React, { useState } from "react";


import "../css/ReviewSlider.css";

const reviews = [


  {
    name: "Priya, Mumbai",
    text: "Fast assistance and smooth process."
  },

  {
    name: "Sahil, Delhi",
    text: "Highly reliable tour and travel service."
  },

  {
    name: "Amit, Bangalore",
    text: "Very professional and quick response."
  },

  {
    name: "Neha, Jaipur",
    text: "Amazing experience. Highly recommended."
  },

  {
    name: "Ajay, Haridwar",
    text: "Go to website to book ranthambore tour packages. Highly recommended."
  },

  {
    name: "Sushil, Ghaziabad",
    text: "They were very helpful in assisting us with our Ranthambore trip and guiding us through the process."
  },

  {
    name: "Aman, Ahmedabad",
    text: "Very helpful and dedicated staff. They provided great booking assistance."
  }

];

export default function ReviewsSlider() {

  const [index, setIndex] = useState(0);

  const next = () => {
    setIndex(index === reviews.length - 2 ? 0 : index + 1);
  };

  const prev = () => {
    setIndex(index === 0 ? reviews.length - 2 : index - 1);
  };

  return (

    <div className="slider-container">

      <div className="slider-controls">

        <button onClick={prev} className="slider-button left">
          ←
        </button>

        <button onClick={next} className="slider-button right">
          →
        </button>

      </div>

      <div className="slider-card">

        <div className="stars">★★★★★</div>

        <p>{reviews[index].text}</p>

        <b>{reviews[index].name}</b>

      </div>

      <div className="slider-card">

        <div className="stars">★★★★★</div>

        <p>{reviews[index+1].text}</p>

        <b>{reviews[index+1].name}</b>

      </div>

    </div>

  );
}
